import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import List from "app/stores/list"
import { message } from "antd"

export default class Store {
  @observable userList = []
  @observable orgList = []

  @action getUserList = () => {
    return request.get(`${config.backend}/accounts/users`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.userList = res
        return Promise.resolve(res)
      }, err => {
        message.error(err)
        return Promise.reject(err)
      })
  }

  @action getOrgList = () => {
    return request.get(`${config.backend}/accounts/orgs`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.orgList = res
        return Promise.resolve(res)
      }, err => {
        message.error(err)
        return Promise.reject(err)
      })
  }

  @action createBaseline = (data) => {
    return request.post(`${config.backend}/pgs/baselines`)
      .send(data)
      .checkToken()
      .commonDispose()
  }

  @action updateOrg = () => {
    return request.put(`${config.backend}/accounts/orgs/${this.detailData.get('id')}`)
      .send(this.detailData.toJS())
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData.clear()
          this.list.getTableData()
            .then(
              res => {
                this.list.updateTableData(res)
                this.list.initPageIndex()
              }
            )
          return Promise.resolve(res)
        },
        err => {
          message.error(err)
          return Promise.reject(err)
        }
      )
  }

  @action setSwitchState = (record, state) => {
    record.disable = state
  }

  @action toggleSwitch = (record) => {
    if (record.disable) {
      this.enable(record)
    } else {
      this.disable(record)
    }
  }

  @action enable = (record) => {
    return request.put(`${config.backend}/pgs/baselines/${record.id}/enable`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.setSwitchState(record, false)
          message.success('启用成功')
        },
        err => {
          message.error(err)
        }
      )
  }

  @action disable = (record) => {
    return request.put(`${config.backend}/pgs/baselines/${record.id}/disable`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.setSwitchState(record, true)
          message.success('停用成功')
        },
        err => {
          message.error(err)
        }
      )
  }

  @action updateField = (e, field) => {
    this.submitData[field] = e.target.value
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "pgs/baselines")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/preview/baseline.js